/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the ProductInstanceList component.
 */
export const PRODUCT_INSTANCE_LIST_DATA_IDS = {
  productInstanceLink: `Link: Product Instance`,
};
